import { render, staticRenderFns } from "./UpgradeMajorManage.vue?vue&type=template&id=d49fa348&scoped=true"
import script from "./UpgradeMajorManage.vue?vue&type=script&lang=js"
export * from "./UpgradeMajorManage.vue?vue&type=script&lang=js"
import style0 from "./UpgradeMajorManage.vue?vue&type=style&index=0&id=d49fa348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49fa348",
  null
  
)

export default component.exports